import getBonusProgramsRef from './getBonusProgramsRef';
import getBonusPeriodsRef from './getBonusPeriodsRef';
import getAutoInviteSettingsRef from './getAutoInviteSettingsRef';
import getDriverRewardsOutputRef from './getDriverRewardsOutputRef';
import getBonusRecordTaggingConfigRef from './getBonusRecordTaggingConfigRef';
import getBonusRecordTaggingConfigsRef from './getBonusRecordTaggingConfigsRef';
import getBonusTagsRef from './getBonusTagsRef';
import getBonusReasonCodesRef from './getBonusReasonCodesRef';
import getBonusOverrideSettingsRef from './getBonusOverrideSettingsRef';
import getBonusAdditionalPaymentSettingsRef from './getBonusAdditionalPaymentSettingsRef';

const scoring = {
  getBonusProgramsRef,
  getBonusPeriodsRef,
  getAutoInviteSettingsRef,
  getDriverRewardsOutputRef,
  getBonusRecordTaggingConfigRef,
  getBonusRecordTaggingConfigsRef,
  getBonusTagsRef,
  getBonusReasonCodesRef,
  getBonusOverrideSettingsRef,
  getBonusAdditionalPaymentSettingsRef,
};

export default scoring;
